import React, { useState, useRef } from 'react'
import { Button, Input, Checkbox } from '@arnsbogroup/react-voicearchive'
import Icon from 'components/Icon'
import messages from './messages'
import useUrl from 'useUrl'
import { FormattedMessage, useIntl } from 'react-intl'
import useOnClickOutside from 'hooks/useOnClickOutside'
import { useKeyboardShortcut } from '@arnsbogroup/react-voicearchive/lib/hooks'
import { isEmail } from 'utils'

const DownloadModal = ({ onClose, onSubmitEmail, hasEmail }) => {
  const container = useRef()
  const [email, setEmail] = useState(null)
  const [subscribeToNewsletter, setSubscribeToNewsletter] = useState(true)
  const { formatMessage, locale } = useIntl()

  useOnClickOutside(container, onClose)
  useKeyboardShortcut(['Escape'], onClose)

  return (
    <div className="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center z-50">
      <div className="fixed inset-0 transition-opacity">
        <div className="absolute inset-0 bg-grayscale opacity-50"></div>
      </div>

      <form
        onSubmit={() => onSubmitEmail({email, subscribeToNewsletter})}
        className="bg-white rounded overflow-hidden shadow transform transition-all sm:max-w-lg sm:w-full"
        role="dialog"
        aria-modal="true"
        ref={container}
      >
        <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3
              className="text-sm leading-6 font-medium text-gray-900 uppercase"
              id="modal-headline"
            >
              <FormattedMessage {...messages.modalTitle} />
            </h3>

            <div className="mt-2 space-y-2 text-sm leading-5 text-gray-900">
              <FormattedMessage
                {...messages[hasEmail ? 'modalBody' : 'modalBodyGate'] }
                tagName="p"
                values={{
                  icon: <Icon icon="download" />,
                  terms: (
                    <a
                      className="text-primary cursor-pointer"
                      href={formatMessage(messages.termsHref)}
                      target="_blank"
                    >
                      <FormattedMessage {...messages.terms} />
                    </a>
                  ),
                }}
              />
            </div>
          </div>
        </div>

        { !hasEmail &&
          <div className="space-y-2 bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <Input
              type="email"
              label="Enter your e-mail"
              placeholder="name@company.com"
              value={email}
              onChange={({ target: { value } }) => setEmail(value)}
            />
            <Checkbox
              onChange={() => {setSubscribeToNewsletter(!subscribeToNewsletter)}}
              checked={subscribeToNewsletter}
              label={formatMessage(messages.subscribeToNewsletter)}
            />
          </div>
        }

        <div className="p-4 sm:px-6 sm:flex sm:flex-row-reverse">
          <span className="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <Button variant="outline" className="w-full md:w-auto" onClick={onClose}>
              <FormattedMessage {...messages.close} />
            </Button>
          </span>

          <span className="mt-3 flex w-full rounded-md shadow-sm sm:ml-3 sm:mt-0 sm:w-auto">
            { !hasEmail ? (
              <Button
                type="submit"
                disabled={!isEmail(email) || !subscribeToNewsletter}
                onClick={() => onSubmitEmail({email, subscribeToNewsletter})}
                className="w-full md:w-auto"
              >
                <FormattedMessage {...messages.submit} />
              </Button>
            ) : (
              <Button className="w-full md:w-auto" onClick={onClose}>
                <FormattedMessage {...messages.download} />
              </Button>
            ) }
          </span>
        </div>
      </form>
    </div>
  )
}

export default DownloadModal
